<template>
  <main class="container">
    <ExploreNav></ExploreNav>
    <div class="row">
      <div id="alphabetic" class="white-box container col-lg-6 offset-lg-3 col-md-8 offset-md-2 col-12">

        <ul id="alfabethic-list" class="scroll-list white-box" aria-label="Liste over bogstaver for temaer">
          <router-link :to="{ path: '/alphabetic/A' }" aria-label="Gå til starten af listen." class="sr-only"></router-link>
          <li v-for="(letter, index) in sortedAlphabeticList.letters" :key="index">
            <router-link :to="{path: '/alphabetic/'+letter}" :aria-label="'Gå direkte til '+letter">
              {{ letter }}
            </router-link>
          </li>
        </ul>

        <div class="col-12 no-pad-both">
          <ul v-for="(letter, index) in sortedAlphabeticList.letters" :key="index" class="alphabetic-collection">
            <li class="col-12 alphabetic-headline">
              <h4 :id="letter">{{ letter }}</h4>
            </li>
            <li v-for="(tag, index) in sortedAlphabeticList[letter]" class="col-12 alphabet-box">
              <router-link :to="{path: '/tag/'+tag.id}" :aria-label="'Gå til '+tag.name_plural">{{ tag.name_plural || tag.name }}</router-link>
            </li>
          </ul>
        </div>

      </div>
    </div>
  </main>
</template>

<script>
import ExploreNav from '@/components/ExploreNav.vue'
import DataManager from '@/assets/DataManager.js'

export default {
  data() {
    return {
      alphabeticListIds: {},
      AlphabeticList: [],
      sortedAlphabeticList: { letters: []},
      tagList: {},
    }
  },
  components: {
    ExploreNav
  },
  props: {
    letter: {
      type: String,
    }
  },
  watch: {
    letter() {
      this.scrollToLetter();
    }
  },
  created() {
    if(this.$props.letter == undefined) {
      this.$HelperFunctions.scrollToTop();
    }
    DataManager.getData([
        DataManager.tagList,
      ], (response) => {
        this.tagList = response[0].data;
        this.getAlphabeticData();
    });
    this.$HelperFunctions.setPageTitle('A-Å');
  },

  mounted() {
    document.getElementById('alphabetic-tab').classList.add('active');
    this.$HelperFunctions.setScreenReaderFocus();
  },

  methods: {
    getAlphabeticData() {
      DataManager.getData([
          DataManager.alphabeticListData,
        ], (response) => {
          this.alphabeticListIds = response[0].data;

          for(var i = 0; i < this.alphabeticListIds.length; i++) {
            for(var k in this.tagList) {
              if(this.tagList[k].id == this.alphabeticListIds[i]) {
                this.AlphabeticList.push(this.tagList[k]);
              }
            }
      		}

      		// array to store non-letter entries
      		var addLast = [];

      		for(var i = 0; i < this.AlphabeticList.length; i++) {
      			var itemLetter = this.AlphabeticList[i].name.substring(0,1).toUpperCase();

      			// if it's not a letter we save it for later
      			if(!this.isLetter(itemLetter)){
      				addLast[itemLetter] = i;
      				continue;
      			}

      			else if(!(itemLetter in this.sortedAlphabeticList)) {
      				this.sortedAlphabeticList[itemLetter] = [];
      				this.sortedAlphabeticList.letters.push(itemLetter);
      			}
      			this.sortedAlphabeticList[itemLetter].push(this.AlphabeticList[i]);
      		}


      		// add non-letter entries
      		for(var a in addLast) {
      			this.sortedAlphabeticList[a] = [];
      			this.sortedAlphabeticList.letters.push(a);
      			this.sortedAlphabeticList[a].push(this.AlphabeticList[addLast[a]]);
      		}
          //console.log(this.sortedAlphabeticList);
          setTimeout(() => {
            this.scrollToLetter();
          }, 500);
      });
    },

    isLetter(str) {
  	  return str.length === 1 && str.match(/[a-z]/i);
  	},

    scrollToLetter() {
      if(this.letter != undefined) {
        var offset = -60;
        var position = document.getElementById(this.letter).getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({top: position-60, behavior: 'smooth'});
        this.$HelperFunctions.setScreenReaderFocus(this.letter);
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  @media screen and (max-width: 767px) and (orientation: portrait) {
    #alphabetic {
      padding-left: 5px;
      padding-right: 5px;
    }
  }

  .alphabetic-collection {
    padding-top: 10px;
  	margin-bottom: 0px;
  }

  .alphabetic-headline {
    padding: 5px;
  	background-color: #f1f1f1;
  }

  h4 {
    margin-bottom: 0px;
  }

  .alphabet-box {
  	background-color: #fdfdfd;
  	padding: 10px 10px 10px 10px;
  	border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
  }

  .alphabet-box a {
  	margin: 0px;
  	display: block;
  	width: 100%;
  	height: 100%;
  }

  .scroll-list {
  	position: fixed;
  	z-index: 10;
  	top: 120px;
  	width: 2em;
  	right: 5px;
  	border-radius: 2px;
  	border: 1px solid #f1f1f1;
  	text-align: center;
  }

  .scroll-list li {
  	height: 1.2em;
  	border-bottom: 1px solid #f1f1f1;
  }

  @media screen and (min-width: 767px) {
  	.scroll-list {
  		width: 4em;
  	}

  	.scroll-list li {
  		height: 2em;
  		line-height: 2em;
  	}
  }

  @media screen and (min-width: 1200px) {
  	.scroll-list {
  		left: 70%;
  	}
  }

  .scroll-list a:last-child li {
  	border-bottom: none;
  }
</style>
